<template>
  <v-card>
    <v-alert type="info" :value="true" class="mb-0">
      {{ $t('texts.dashboard.assignmentDescription') }}
    </v-alert>
    <v-card-text>
      <v-container class="pa-0">
        <v-row v-if="formattedItems > 5">
          <v-col :cols="12" :md="3" :offset-md="9">
            <v-text-field
              append-icon="search"
              :label="$t('texts.search')"
              single-line
              hide-details
              v-model="search"
              style="max-width: 300px"
            />
          </v-col>
        </v-row>
      </v-container>
      <v-row>
        <v-col :cols="12">
          <v-data-table
            :headers="headers"
            :items="formattedItems"
            :search="search"
            must-sort
            :no-data-text="$t('texts.employee.noEntries')"
            :no-results-text="$t('texts.noSearchEntries')"
            :footer-props="{ itemsPerPageText: $t('texts.rowsPerPage')}"
            class="elevation-0"
            :loading="fetchEmployeesAssignmentPending"
            :hide-default-footer="formattedItems.length < 5"
          >
            <template v-slot:item.actions="{ item }">
              <v-tooltip color="green" top>
                <template v-slot:activator="{ on }">
                  <v-btn
                    v-on="on"
                    icon class="mx-0"
                    :disabled="!hasActiveSubscription"
                    @click="updateEmployeeAssignment({
                      type: 'approve',
                      companyId: selectedCompanyId,
                      entryId: item.resume_entry_id,
                    })"
                  >
                    <v-icon color="green">check</v-icon>
                  </v-btn>
                </template>
                <span>{{ $t('texts.confirm') }}</span>
              </v-tooltip>
              <v-tooltip color="red" top>
                <template v-slot:activator="{ on }">
                  <v-btn
                    v-on="on"
                    icon class="mx-0"
                    :disabled="!hasActiveSubscription"
                    @click="openDeclineEmployeeDialog(item)"
                  >
                    <v-icon color="red">close</v-icon>
                  </v-btn>
                </template>
                <span>{{ $t('texts.decline') }}</span>
              </v-tooltip>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';

const { mapState: mapCompanyProfileState } = createNamespacedHelpers('company/profile');
const { mapState: mapCompanyEmployeesState, mapActions: mapCompanyEmployeesActions } = createNamespacedHelpers('company/employees');

export default {
  name: 'CompanyEmployeeAssignment',
  data() {
    return {
      search: '',
    };
  },
  $_veeValidate: {
    validator: 'new',
  },
  created() {
    this.fetchEmployeesAssignment(this.selectedCompanyId);
  },
  computed: {
    ...mapCompanyProfileState([
      'company',
    ]),
    ...mapCompanyEmployeesState([
      'fetchEmployeesAssignmentPending',
      'employeesAssignment',
    ]),
    headers() {
      const headers = [
        {
          text: `${this.$i18n.t('texts.firstName')} ${this.$i18n.t('texts.lastName')}`,
          value: 'formattedName',
          align: 'left',
        },
        {
          text: this.$i18n.t('texts.insertJobtitle'),
          value: 'title',
          align: 'left',
        },
        {
          text: this.$i18n.t('texts.startOfWork'),
          value: 'formattedStartDate',
          align: 'left',
        },
        {
          text: this.$i18n.t('texts.endOfWork'),
          value: 'formattedEndDate',
          align: 'left',
        },
        {
          text: '',
          value: 'actions',
          sortable: false,
          align: 'right',
        },
      ];
      return headers;
    },
    formattedItems() {
      if (this.employeesAssignment.length > 0) {
        return this.employeesAssignment.map((item) => {
          const formattedName = `${item.employee_first_name} ${item.employee_last_name}`;
          const formattedStartDate = this.$options.filters.formatDateShort(item.start_date);
          const formattedEndDate = this.$options.filters.formatDateShort(item.end_date);
          const formattedItem = {
            ...item,
            formattedName,
            formattedStartDate,
            formattedEndDate,
          };
          return formattedItem;
        });
      }
      return [];
    },
    selectedCompanyId() {
      return this.$route.params.companyId;
    },
    hasActiveSubscription() {
      return this.company.active_subscription;
    },
  },
  methods: {
    ...mapCompanyEmployeesActions([
      'fetchEmployeesAssignment',
      'updateEmployeeAssignment',
    ]),
    initialize() {
      this.fetchEmployeesAssignment(this.selectedCompanyId);
    },
    openDeclineEmployeeDialog(employee) {
      this.$eventBus.$emit('show-decline-employee-dialog', employee);
    },
  },
};
</script>
